export const SOURCE = {
  FM: 'FM',
  IL: 'FL'
}

export const SOURCE_VALUES = Object.values(SOURCE)

export const PROJECT_SITE = {
  FM: 'FM',
  FM_DIR: 'FMDir',
  IL: 'FL',
  IL_DIR: 'FLDir'
}
